import { render, staticRenderFns } from "./fileBrowsing.vue?vue&type=template&id=ef285b5e&scoped=true"
import script from "./fileBrowsing.vue?vue&type=script&lang=js"
export * from "./fileBrowsing.vue?vue&type=script&lang=js"
import style0 from "./fileBrowsing.vue?vue&type=style&index=0&id=ef285b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef285b5e",
  null
  
)

export default component.exports